/* eslint-disable eqeqeq */
import { SYS_ENVIRONMENT, PROD_LINK, SANDBOX_LINK, DEV_LINK, ALL_SERVICES_VISIBLE } from 'constant';

// environments information to show true env. link to user
const prodObject = {
  title: 'تولید',
  url: PROD_LINK,
};
const sandboxObject = {
  title: 'سندباکس',
  url: SANDBOX_LINK,
};
const devObject = {
  title: 'توسعه',
  url: DEV_LINK,
};

// availability of each page and its isBI
export const SERVICES_AVAILABILITY = {
  // dashboard
  totalCustomers: {
    prod: true,
    sandbox: false,
    development: true,
    isBI: true,
  },
  totalIncome: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  invoiceDebtor: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: false,
  },
  factorsCreditor: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: false,
  },
  sentRequests: {
    prod: true,
    sandbox: false,
    development: true,
    isBI: true,
  },
  receivedRequests: {
    prod: true,
    sandbox: false,
    development: true,
    isBI: true,
  },
  transactionBills: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  WalletAndGuild: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  incomeByGuild: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  reportSettlement: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  receivedDelegation: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  customers: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  myServiceSets: {
    prod: true,
    sandbox: true,
    development: true,
    isBI: true,
  },
  myServiceCalls: {
    prod: true,
    sandbox: false,
    development: true,
    isBI: true,
  },
  serviceCalls: {
    prod: true,
    sandbox: false,
    development: true,
    isBI: true,
  },
};

export const isAvailable = (pageKey) => {
  if (ALL_SERVICES_VISIBLE != 'false' || !pageKey || !SERVICES_AVAILABILITY.hasOwnProperty(pageKey))
    return true;

  if (SYS_ENVIRONMENT === 'production' && SERVICES_AVAILABILITY[pageKey]?.prod) return true;
  if (SYS_ENVIRONMENT === 'sandbox' && SERVICES_AVAILABILITY[pageKey]?.sandbox) return true;
  if (SYS_ENVIRONMENT === 'development' && SERVICES_AVAILABILITY[pageKey]?.development) return true;

  return false;
};

export const whereIsAvailable = (pageKey) => {
  const availableEnvs = [];

  if (!pageKey || !SERVICES_AVAILABILITY.hasOwnProperty(pageKey)) return availableEnvs;

  if (SERVICES_AVAILABILITY[pageKey]?.prod) availableEnvs.push(prodObject);
  if (SERVICES_AVAILABILITY[pageKey]?.sandbox) availableEnvs.push(sandboxObject);
  if (SERVICES_AVAILABILITY[pageKey]?.development) availableEnvs.push(devObject);

  return availableEnvs;
};

export const isBIReport = (pageKey) => {
  if (!pageKey || !SERVICES_AVAILABILITY.hasOwnProperty(pageKey)) return false;
  if (SERVICES_AVAILABILITY[pageKey]?.isBI) return true;
  return false;
};
